import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=1ef429a2&scoped=true&"
import script from "./categories.vue?vue&type=script&lang=js&"
export * from "./categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef429a2",
  null
  
)

export default component.exports